<template>
  <div id="app">
    <Header></Header>
    <main class="main-app-content">
      <router-view/>
    </main>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.fetchGlobalSettings();
  },
  methods: {
    async fetchGlobalSettings() {
      try {
        const res = await fetch('/api/settings');
        const json = await res.json();
        if (json.code === 200 && json.data) {
          const title = json.data.siteTitle || '班米电商';
          window.__SITE_TITLE__ = title;
          document.title = title;
          if (json.data.siteFavicon) {
            this.updateFavicon(json.data.siteFavicon);
          }
        }
      } catch (e) {}
    },
    updateFavicon(iconUrl) {
      if (!iconUrl) return;
      const head = document.getElementsByTagName('head')[0];
      const existingIcons = document.querySelectorAll("link[rel*='icon']");
      existingIcons.forEach(el => el.parentNode.removeChild(el));

      const link = document.createElement('link');
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = iconUrl;
      head.appendChild(link);
    }
  }
}
</script>

<style>
/* 保证页面全屏高度贴底布局 (Sticky Footer) */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
}

.main-app-content {
  flex: 1 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.main-app-content > div {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 飞书蓝 (Feishu/Lark Blue) 全局主题色应用 */
:root {
  --feishu-blue: #3370FF;
  --feishu-blue-hover: #4E83FF;
  --feishu-blue-active: #2B5AED;
  --feishu-light-bg: #F0F5FF;
}

/* Override Bootstrap Primary and Info Buttons to Feishu Blue */
.btn-info,
.btn-primary {
  background-color: #3370FF !important;
  border-color: #3370FF !important;
  color: #ffffff !important;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #2B5AED !important;
  border-color: #2B5AED !important;
}

a {
  color: #3370FF;
}

a:hover,
a:focus {
  color: #2B5AED;
  text-decoration: none;
}

/* 子页面顶头 Banner 默认渐变背景 */
.banner {
  color: #fff;
  font-size: 30px;
  height: 150px;
  line-height: 150px;
  background: linear-gradient(135deg, #101F42 0%, #1B4299 50%, #3370FF 100%);
  background-size: cover;
  background-position: center center;
}

/* Swiper Pagination Active Bullet */
.swiper-pagination-bullet-active {
  background: #3370FF !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue